import { DesignProps } from 'api/DesignApi';
import imageLogoTextFull from 'assets/logo-text-full.svg';
import imageLogoVerticalImage from 'assets/logo-vertical.svg';
import imageLogo from 'assets/logo.svg';
import { useCompanyContext } from 'contexts/CompanyContext';
import './LogoComponent.css';

type AllProps = {
  companyConfig?: DesignProps;
  variant?: 'vertical' | 'horizontal' | 'text';
  maxHeight?: number | string;
  maxWidth?: number | string;
};

function LogoComponent({ companyConfig, variant, maxHeight, maxWidth }: AllProps) {
  const { companyConfig: defaultCompanyConfig } = useCompanyContext();

  companyConfig = companyConfig ?? defaultCompanyConfig;

  const defaultLogoSrc =
    variant === 'vertical' ? imageLogoVerticalImage : variant === 'text' ? imageLogoTextFull : imageLogo;
  const logoSrc = companyConfig.logoUrl ?? defaultLogoSrc;

  return (
    <img
      src={logoSrc}
      alt=""
      style={{
        maxHeight: maxHeight ?? 'auto',
        maxWidth: maxWidth ?? 'auto'
      }}
    />
  );
}

export default LogoComponent;
